import { I18n } from '@calendly/i18n';
import { Spotlight, useSpotlight } from '@calendly/ui/components/spotlight';
import { Children, cloneElement, isValidElement, useMemo, useRef } from 'react';
import { SPOTLIGHT_TOUR_PRIORITY } from 'shared/constants/spotlight_tours';
import { useAiChatDiscoveryEntrySpotlight } from './hooks/use_ai_chat_discovery_entry_spotlight';
const anchorCss = "a18kcj11";

/**
 * Anchors shared discovery spotlight copy to a child entry button (top bar or FAB).
 *
 * @param {Object} props
 * @param {string} props.spotlightKey — `activation_data.spotlights` key from {@link AI_CHAT_DISCOVERY_SPOTLIGHT_KEY}
 * @param {string} props.flowId — unique CUI spotlight flow id per entry point
 * @param {boolean} props.isEntryVisible — entry control is on screen
 * @param {import('react').ReactNode} props.children — the Ask Callie button
 */
const AiChatDiscoveryEntrySpotlightContent = ({
  spotlightKey,
  flowId,
  isEntryVisible,
  children
}) => {
  const anchorRef = useRef(null);
  const {
    handleClose
  } = useSpotlight();
  const {
    shouldShowSpotlight,
    dismissSpotlight
  } = useAiChatDiscoveryEntrySpotlight(spotlightKey, isEntryVisible);
  const steps = useMemo(() => [{
    ref: anchorRef,
    title: I18n.t('publisher.agent_hub.discovery_fab.entry_spotlight.heading'),
    text: I18n.t('publisher.agent_hub.discovery_fab.entry_spotlight.body')
  }], []);
  const entryButton = useMemo(() => Children.map(children, child => {
    if (!isValidElement(child)) {
      return child;
    }
    const {
      onClick: childOnClick
    } = child.props;
    return cloneElement(child, {
      onClick: event => {
        if (shouldShowSpotlight) {
          handleClose(flowId, 'entry_click');
        }
        childOnClick?.(event);
      }
    });
  }), [children, flowId, handleClose, shouldShowSpotlight]);
  return <>
      <span ref={anchorRef} className={anchorCss}>
        {entryButton}
      </span>
      <Spotlight flowId={flowId} shouldShow={shouldShowSpotlight} steps={steps} priority={SPOTLIGHT_TOUR_PRIORITY.AI_CHAT_DISCOVERY} onComplete={dismissSpotlight} onExit={dismissSpotlight} />
    </>;
};
export const AiChatDiscoveryEntrySpotlight = props => <AiChatDiscoveryEntrySpotlightContent {...props} />;

require("./AiChatDiscoveryEntrySpotlight.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AiChatDiscoveryEntrySpotlight.js");